import type { VoterMapPoint } from './stores/voters';

/** A leaflet.heat point: [lat, lng, intensity]. */
export type HeatPoint = [number, number, number];

/**
 * Heatmap input for the "uncontacted density" view: one point per voter that
 * has NEVER been contacted, is not flagged do-not-contact, and has valid
 * coordinates. Every such voter contributes equal intensity (1) so the heat
 * reflects raw density of unknocked doors.
 */
export function heatPoints(points: VoterMapPoint[]): HeatPoint[] {
  const out: HeatPoint[] = [];
  for (const p of points) {
    if (p.latest_contact_result !== null) continue; // already contacted
    if (p.do_not_contact) continue;                 // do not knock
    if (p.lat == null || p.lng == null) continue;   // no geocode
    out.push([p.lat, p.lng, 1]);
  }
  return out;
}
